<template>
  <div>
    <div class="eval-mine">
<!--      <img src="@/assets/mine/avatar.png" class="avatar_small" />-->
<!--      <div>-->
<!--        <div class="ft-28 c-black mb-10">王玥</div>-->
<!--        <div class="ft-20 c-a8">1小时前评价</div>-->
<!--      </div>-->
    </div>
    <div class="flex align-center ft-24 ml-30">
      <div class="c-a8 mr-15">业务名称：</div>
      <div class="c-66 mr-40">{{ ticketInfo.bizName }}</div>
      <div class="c-a8 mr-15">票号：</div>
      <div class="c-66">{{ ticketInfo.ticketNo }}</div>
    </div>
    <div class="eval-item" v-for="(item, index) in todolist" :key="index">
      <van-row type="flex" align="center" class="mb-40">
        <van-col class="ft-30 c-black" span="6">服务评价</van-col>
        <van-col class="ft-30 c-black" span="18"
          ><van-rate
            v-model="item.evalCode"
            :size="25"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
        /></van-col>
      </van-row>
      <div class="ft-24 c-black pb-40 b-b mb-30">
        <span class="c-66">我说：</span>{{ item.evalContent }}
      </div>
      <div class="ft-20 c-black">
        <span class="c-66">评价时间：</span>{{ item.evalTime }}
      </div>
    </div>
    <div class="eval-btn">
      <van-button type="primary" color="#f5f5f5" class="blue-common-btn" block @click="bindEval">评价</van-button>
    </div>
  </div>
</template>

<script>
import { getEvalList, ticketDetail } from "@/api/index";
export default {
  data() {
    return {
      todolist: [],
      ticketInfo: {},
    };
  },
  created() {
    this.init();
    this.initTicket();
  },
  methods: {
    init() {
      let params = {
        clientId: this.$route.params.clientId,
        type: 1,
        ticketId: this.$route.query.ticketId,
      };
      getEvalList(params).then((response) => {
        this.todolist = response.data || [];
      });
    },
    initTicket() {
      ticketDetail(
        this.$route.params.clientId,
        this.$route.query.ticketId
      ).then((res) => {
        this.ticketInfo = res.data;
      });
    },
		bindEval() {
			this.$router.push({ path: `eval?ticketId=${this.$route.query.ticketId}` })
		}
  },
};
</script>

<style lang="scss" scoped>
.eval-mine {
  padding: 40px 30px;
  display: flex;
  align-items: center;
  .avatar_small {
    width: 70px;
    height: 70px;
    margin-right: 20px;
  }
}
.eval-item {
  border-radius: 16px;
  padding: 40px 30px;
  margin-top: 20px;
  background-color: #fff;
}
.eval-btn {
  margin: 60px 30px 0;
}
</style>